// Brand typefaces. Self-hosted; the @font-face rules live in app/gatsby-ssr.js.
// Reference these as tokens (fontFamily="larsseit"), never as raw family strings.
//
// NOTE: these are bare family names with no fallback stack, which is exactly what
// the codebase rendered before they were tokenised. Adding fallbacks changes what
// shows while the webfont loads or if it fails to, so that is a separate decision.
const larsseit = "Larsseit"
const graphik = "Graphik"

export const fonts = {
  larsseit,
  graphik,
  beni: "Beni",
  mono: "Courier",

  // Chakra's semantic aliases, pointed at the faces actually in use.
  // `heading` matches Heading.ts (h1-h5) and the h1-h4 rules in styles.ts;
  // `body` matches the global <body> rule in styles.ts. Paragraph and UI text
  // is Graphik via the Text component, not via this alias.
  heading: larsseit,
  body: larsseit,

  skinQuiz: {
    heading: "Beni",
  },
}
